import { isString } from 'lodash-es';
import { h } from 'vue';
import type { VNode } from 'vue';
import { MIcon } from '@mts/components/Icon';

export const TreeIcon = ({ icon }: { icon: VNode | string | undefined }) => {
  if (!icon) return null;
  if (isString(icon)) {
    return h(MIcon, { icon, class: 'mr-2' });
  }
  return h(MIcon);
};
